/* eslint-disable react/prop-types */
import { Controller } from 'react-hook-form'
import { Link } from 'react-router-dom'
import { ReturnIcon } from '../../assets/icons/Return'
import { Checkbox } from '../../components/Checkbox/Checkbox'
import ToggleSwitch from '../../components/Switch/Switch'
import { ContainerTitle } from '../../components/TitlePage/TitlePage'
import { Tour } from '../../components/Tour'
import TourUsuariosPermissoes from '../../utils/JoyRide/tourUsuariosPermissoes'
// import { phoneMask } from '../../utils/masks'
import { DivTop, Span } from '../PredictionDetails/PredictionDetails.style'
import { IFormInputs } from './NewUser.interface'
import {
  Acessos,
  B,
  BtnSave,
  // Byes,
  DivAccess,
  // DivAdm,
  DivForm,
  FormLogin,
  InputLogin,
  LabelLSwitch,
  LabelLogin,
  PrincipalDiv,
  // SpanAdm,
} from './NewUsers.style'
import { useNewUsers } from './useNewUsers'

const Vendedores = [
  {
    id: 6,
    name: 'Administrador',
  },
  {
    id: 1,
    name: 'Vendedor1',
  },
  {
    id: 2,
    name: 'Vendedor2',
  },
  {
    id: 3,
    name: 'Vendedor3',
  },
  {
    id: 4,
    name: 'Vendedor4',
  },
  {
    id: 5,
    name: 'Vendedor5',
  },
]

export function NewUsers() {
  const user = localStorage.getItem('usuario')
  const usuario = user ? JSON.parse(user) : null

  const {
    // adminId,
    accessList,
    control,
    emailValidation,
    // handleGetId,
    register,
    statusLabel,
  } = useNewUsers()

  return (
    <>
      <ContainerTitle id="saudacaoUsuariosPermissoes">
        <DivTop id="finalizacaoUsuarioPermissoes">
          <Link to="/usuarios&permissoes">
            <ReturnIcon />
          </Link>
          <Span>Novo Usuário</Span>
        </DivTop>
        <Tour steps={TourUsuariosPermissoes} />
      </ContainerTitle>
      <PrincipalDiv>
        <form>
          <h3>Dados do usuário</h3>
          <DivForm id="cadastro">
            <FormLogin>
              <LabelLogin htmlFor="name">Nome Completo</LabelLogin>
              <InputLogin
                {...register('name')}
                id="name"
                type="text"
                readOnly
                value={usuario.nome}
              />
            </FormLogin>

            <FormLogin>
              <LabelLogin htmlFor="email">E-mail</LabelLogin>
              <InputLogin
                {...register('email', emailValidation)}
                id="email"
                type="text"
                readOnly
                value={usuario.email}
              />
            </FormLogin>

            {/* <FormLogin>
              <LabelLogin htmlFor="phone">Telefone</LabelLogin>
              <InputLogin
                {...register('phone')}
                id="phone"
                type="text"
                onChange={e => {
                  e.target.value = phoneMask(e.target.value)
                }}
              />
            </FormLogin> */}

            {/* <FormLogin>
              <LabelLogin htmlFor="password">Senha</LabelLogin>
              <InputLogin
                {...register('password')}
                id="password"
                type="password"
              />
            </FormLogin>

            <FormLogin>
              <LabelLogin htmlFor="confirmPassword">Confirmar Senha</LabelLogin>
              <InputLogin
                {...register('confirmPassword')}
                id="confirmPassword"
                type="password"
              />
            </FormLogin> */}
            <FormLogin id="ativoInativo">
              <LabelLSwitch htmlFor="name">Situação</LabelLSwitch>
              <Controller
                name="isActive"
                control={control}
                render={({ field: { ref, ...field } }) => (
                  <ToggleSwitch id="status" label={statusLabel} {...field} />
                )}
              />
            </FormLogin>
          </DivForm>
          <Acessos>
            <label htmlFor="email">Nível de acesso</label>
            <select>
              <option hidden>.</option>
              {Vendedores.map(User => (
                <option>{User.name}</option>
              ))}
            </select>
          </Acessos>
          <DivAccess id="permissoesAcesso">
            <h4>Empresas</h4>
            {Object.keys(accessList).map((value: string) => (
              <Controller
                key={value}
                name={`access[${value}]` as keyof IFormInputs}
                control={control}
                render={({ field: { ref, ...field } }) => (
                  <span key={value}>
                    <Checkbox
                      top="2px"
                      type="checkbox"
                      {...field}
                      value={value}
                    />
                    <B>{accessList[value]}</B>
                  </span>
                )}
              />
            ))}
          </DivAccess>
          {/* <DivAdm id="permissoesAdm">
            <h4>Administrador</h4>
            <SpanAdm>
              <Checkbox
                id="admin"
                checked={adminId === 'admin'}
                onChange={handleGetId}
              />
              <Byes>Sim</Byes>
              <Checkbox
                id="not-admin"
                checked={adminId === 'not-admin'}
                onChange={handleGetId}
              />
              <b>Não</b>
            </SpanAdm>
            <div>
              <h3>Empresas</h3>
            </div>
          </DivAdm> */}

          <BtnSave id="salvar" type="submit">
            Salvar
          </BtnSave>
        </form>
      </PrincipalDiv>
    </>
  )
}
